<template>
  <v-container fluid>
    <!-- <v-row class="mx-1">
      <v-col cols="auto" class="my-0">
        <FilterBar
          :filter="filter"
          @changed="changed"
          :elements="['date']"
          :dateOptions="dateOptions"
      />
</v-col>
      <v-spacer>
</v-spacer>
    </v-row> -->
    <v-row class="mx-0">
      <v-col sm="6" md="2">
        <StatsCard
          color="light-blue"
          :data="stats.plans"
          icon="mdi-flask-outline"
          label="Test Cases"
          link="plans"
        />
      </v-col>
      <v-col sm="6" md="2">
        <StatsCard
          color="green"
          :data="stats.results"
          icon="mdi-clipboard-list-outline"
          label="Results"
          link="results"
        />
      </v-col>
      <!-- <v-col sm="6" md="2">
        <StatsCard
          color="red"
          :data="stats.pingr"
          icon="mdi-pulse"
          label="Pingr"
          link="pingr"
        />
      </v-col> -->
      <v-col sm="6" md="2">
        <StatsCard
          color="orange"
          :data="stats.suites"
          icon="mdi-package-variant"
          label="Test Suits"
          link="suites"
        />
      </v-col>
      <v-col sm="6" md="2">
        <StatsCard
          color="teal"
          :data="stats.schedule"
          icon="mdi-history"
          label="Scheduler"
          link="scheduler"
        />
      </v-col>
      <v-col sm="6" md="2">
        <StatsCard
          color="indigo"
          :data="stats.keys"
          icon="mdi-key-chain-variant"
          label="API keys"
          link="keys"
        />
      </v-col>
      <v-col sm="6" md="2">
        <StatsCard
          color="cyan"
          :data="stats.users"
          icon="mdi-account"
          label="Users"
          link="users"
        />
      </v-col>
    </v-row>
    <v-row class="mx-0 scrollable mh75">
      <chart-wrap :chartData="testsOverTime" :loading="loading" :col="8" />
      <chart-wrap :chartData="testsRatio" :loading="loading" :col="4" />
      <chart-wrap :chartData="initiators" :loading="loading" :col="3" />
      <chart-wrap :chartData="testsExecution" :loading="loading" :col="6" />
      <chart-wrap :chartData="usage" :loading="loading" :col="3" />
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from "vue";
import ChartWrap from "../components/ChartWrap.vue";
import StatsCard from "../components/StatsCard.vue";

export default Vue.extend({
  name: "DashboardView",
  data() {
    return {
      filterToggle: false,
      filter: {
        limit: 30,
        date: {},
      },
      dateOptions: {
        dateField: "date",
      },
    };
  },
  components: {
    ChartWrap,
    StatsCard,
  },
  methods: {
    async fetchStats() {
      await this.$store.dispatch("fetchStats", this.filter);
    },
    changed() {
      this.fetchStats();
    },
  },
  computed: {
    stats() {
      return this.$store.getters.getStats;
    },
    labels() {
      return this.$store.getters.getLabels || [];
    },
    loading() {
      return this.$store.getters.getStatsLoader;
    },
    locations() {
      return this.$store.getters.getLocations || [];
    },
    testsRatio() {
      return this.$store.getters.getTestsRatio;
    },
    initiators() {
      return this.$store.getters.getInitiators;
    },
    testsOverTime() {
      return this.$store.getters.getTestsOverTime;
    },
    testsExecution() {
      return this.$store.getters.getTestsExecution;
    },
    usage() {
      return this.$store.getters.getUsage;
    },
  },
  async mounted() {
    this.$store.commit("setStatsLoader", true);
    await this.fetchStats();
    this.$store.commit("setStatsLoader");
  },
});
</script>
<style scoped>
.filter {
  position: fixed;
  right: 0.5em;
  top: 5em;
}

.closeIcon {
  position: absolute !important;
  z-index: 999;
  top: 1em;
}
.scrollable {
  overflow-x: hidden;
  overflow-y: auto;
  height: 70vh;
}
</style>
